export class IgnoreHardwareCheckChangedRequest {
    LicenseKey: string;
    IgnoreHardwareCheck: boolean;
}
